import BannerDefault from '../../components/BannerDefault';

import style from './somos.module.scss';

const parse = require('html-react-parser');

interface Dados {
  dados: {
    banner: string;
    titulo: string;
    texto: string;
  };
}

export default function Somos({ dados }: Dados) {
  if (!dados) return null;

  return (
    <BannerDefault
      image={{ src: dados.banner }}
      width='100%'
      height='fit-content'>
      <div className={style.text}>
        <p>{parse(dados.texto)}</p>
        <h2>{parse(dados.titulo)}</h2>
        <h2>{parse(dados.titulo)}</h2>
      </div>
    </BannerDefault>
  );
}
